export const hasGrnWeighment = (row) => {
    const gross = parseFloat(row.gross_weight || 0);
    const tare = parseFloat(row.tare_weight || 0);
    return gross > 0 && tare > 0;
};

export const syncGrnLineWithoutWeighment = (row) => {
    row.gross_weight = 0;
    row.tare_weight = 0;
    const acceptedQty = parseFloat(row.accepted_qty || 0);
    const deductionQty = parseFloat(row.deduction_qty || 0);
    row.net_weight = 0;
    row.received_qty = (acceptedQty + deductionQty).toFixed(3);
    const dcQty = parseFloat(row.dc_qty || 0);
    row.difference_qty = (dcQty - parseFloat(row.received_qty)).toFixed(3);
    const rate = parseFloat(row.rate || 0);
    if (rate) {
        row.taxable_amount = (acceptedQty * rate).toFixed(3);
        row.amount = row.taxable_amount;
    }
    return row;
};

export const syncGrnLineWithWeighment = (row) => {
    const grossWeight = parseFloat(row.gross_weight || 0);
    const tareWeight = parseFloat(row.tare_weight || 0);
    const netWeight = (grossWeight - tareWeight).toFixed(3);
    row.net_weight = netWeight;
    const deductionQty = parseFloat(row.deduction_qty || 0);
    const receivedQty = (parseFloat(netWeight) - deductionQty).toFixed(3);
    row.received_qty = receivedQty;
    row.accepted_qty = receivedQty;
    const rate = parseFloat(row.rate || 0);
    if (rate) {
        row.taxable_amount = (parseFloat(receivedQty) * rate).toFixed(3);
        row.amount = row.taxable_amount;
    }
    const dcQty = parseFloat(row.dc_qty || 0);
    row.difference_qty = (dcQty - parseFloat(receivedQty)).toFixed(3);
    return row;
};

export const toGrnFloat = (value) => {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
};
